enum StatsStatic {}

const StatsDynamic = {
  // Aquí se pueden agregar endpoints dinámicos en el futuro si es necesario
  // Por ejemplo: stats por período específico, por usuario, etc.
  /**
   * @member {string}
   * @method get
   * @version 2.0
   * @description get application statistics
   */
  Stats: "/v3/admin/stats"
};

export const StatsEndpoints = {
  ...StatsDynamic,
  ...StatsStatic
};

export type StatsEndpoints = typeof StatsEndpoints;
